import { isNaN, isNil } from "lodash";

export const validateRequiredKeys = <FormType>({
  form,
  requiredKeys,
  errorText = "This field is required",
}: {
  form: FormType;
  requiredKeys: (keyof FormType)[];
  errorText?: string;
}) => {
  const errors: Partial<Record<keyof FormType, string>> = {};

  requiredKeys.forEach((requiredKey) => {
    const formHasPropertyRequiredKey = Object.prototype.hasOwnProperty.call(form, requiredKey);
    if (
      !formHasPropertyRequiredKey ||
      form[requiredKey] === "" ||
      isNil(form[requiredKey]) ||
      isNaN(form[requiredKey])
    ) {
      errors[requiredKey] = errorText;
    }
  });

  return errors;
};

const passwordValidator = (s: string) => {
  const min8Characters = /^[><?@+'`~^%&\*\[\]\{\}.!#|\\\"$';,:;=\/\(\),\-\w]{8,}$/;
  const uppercase = /^(?=.*[a-z])(?=.*[A-Z])/;
  const lowercase = /^(?=.*[a-z])/;
  const number = /^(?=.*\d)/;
  return min8Characters.test(s) && uppercase.test(s) && lowercase.test(s) && number.test(s);
};

export const FORM_VALIDATOR = {
  isPassword: passwordValidator,
};
